/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import moment from 'moment';
import * as actionTypes from './actionTypes';

const initialState = {
  performAdjustedResolutionObj: {},
  rebateProgram: [],
  rebateProgramName: {},
  claimCategoryName: '',
  errorMsgAdjustedClaim: [],
  drugSeqNumber: '',
  drugData: [],
  labelerList: [],
  labelerData: [],
  labelerInfo: [],
  labelerInfoName: [],
  billed: true,
  notBilled: false,
  yes: true,
  no: false,
  invoice: true,
  nonInvoiced: false,

  startQtr: '',
  endQtr: '',
  adjustedGrid: [],
  drugSeqNum: [],
  drugSeqNumDetail: [],
  drugSeqData: [],
  selectBy: 'All',
  claimcategorySelectedValue: '',
  selectedNDC: [],
  ndcLeftTableData: [],
  labelerSelectedRow: [],
  selectRowIndex: 0,
  selectedSearchType: 'Name',
  unitGrid: [],
  providerCd:[],
  displayObj: {
    rebateProgramName: {},
    startQtr: '',
    endQtr: '',
    claimcategorySelectedValue: '',
    billed: true,
    notBilled: false,
    yes: true,
    no: false,
    invoice: true,
    nonInvoiced: false,
    labelerInfoName: [],
    unitGrid: [],
    adjustedGrid: [],
    selectBy: 'All',
    drugSeqNum: [],
    drugSeqNumDetail: [],
    drugSeqData: [],
  },
};
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_CURRENT_ADJUSTED_DISPLAY_OBJ_CLAIM:
      return { ...state, performAdjustedResolutionObj: action.screenData };
    case actionTypes.SET_DRUG_SEQ_NUMBER:
      return { ...state, drugSeqNumber: action.drugSeqNumber };
    case actionTypes.GET_CURRENT_ADJUSTED_DISPLAY_DETAIL_OBJ_CLAIM:
      return { ...state, adjustedResolutionDetailObj: action.detailScrData };
    case actionTypes.GET_ERROR_MSG_ADJUSTED_CLAIM:
      return { ...state, errorMsgAdjustedClaim: action.payload };
    case actionTypes.GET_REBATE_PROGRAM_CLAIM:
      return { ...state, rebateProgram: action.payload };
    case actionTypes.GET_REBATE_PROGRAM_NAME_CLAIM:
      return { ...state, rebateProgramName: action.payload };
    case actionTypes.SET_LABELER_DATA:
      return { ...state, labelerData: action.payload };
    case actionTypes.SET_LABELER_INFO:
      return { ...state, labelerInfo: action.payload };
    case actionTypes.SET_LABELER_INFO_NAME:
      return { ...state, labelerInfoName: action.payload };
    case actionTypes.SET_CLAIM_CATEGORY:
      return { ...state, claimCategory: action.payload };
    case actionTypes.SET_CLAIM_NAME_CATEGORY:
      return { ...state, ...action.payload };
    case actionTypes.GET_ADJUSTED_CLAIMS_UNIT_DATA:
      const displayObj1 = {
        ...state.displayObj,
        unitGrid: action.payload,
      };
      return { ...state, unitGrid: action.payload, displayObj1 };

    case actionTypes.GET_ADJUSTED_CLAIMS_GRID_DATA:
      const displayObj = {
        ...state.displayObj,
        adjustedGrid: action.payload,
        ...action.checkboxValues,
      };
      return {
        ...state,
        adjustedGrid: action.payload,
        displayObj: displayObj,
      };
    case actionTypes.LOAD_DETAIL_SCR:
      return { ...state, detail_loaded: action.payload };
    case actionTypes.SELECTED_LABELER_M:
      return { ...state, selectedlabelerm: action.payload };
    case actionTypes.SET_DISPLAY_OBJ_ADJUSTED:
      const tempObj = JSON.parse(JSON.stringify(action.payload));
      return { ...state, displayObj: tempObj };
    case actionTypes.SET_SELECT_BY:
      return { ...state, selectBy: action.payload };
    case actionTypes.SET_LABELER_LIST:
      return { ...state, labelerList: action.payload };
    case actionTypes.SET_UNIT_CHANGED_TYPE:
      return { ...state, ...action.payload };
    case actionTypes.SET_DISPUTE_RESOLUTION:
      return { ...state, ...action.payload };
    case actionTypes.SET_INVOICE_STATUS:
      return { ...state, ...action.payload };
    case actionTypes.GET_DRUG_DATA_CLAIM:
      return {
        ...state,
        drugData: action.payload.selectedNDC,
        selectedNDC: action.payload.selectedNDC,
        ndcLeftTableData: action.payload.ndcLeftTableData,
        labelerSelectedRow: action.payload.labelerSelectedRow,
      };
    case actionTypes.SET_QUARTER_RANGE_CLAIMS:
      return { ...state, ...action.payload };
    case actionTypes.PAGINATION_DATA_SET:
      return { ...state, paginatelist: action.payload };
    case actionTypes.GET_ADJUSTED_CLAIMS_DRUG_DATA:
      return { ...state, drugSeqNum: action.payload || [] };
    case actionTypes.GET_ADJUSTED_CLAIMS_DRUG_DATA_NAME:
      const displayObj2 = {
        ...state.displayObj,
        drugSeqNumDetail: action.payload,
      };
      return {
        ...state,
        drugSeqNumDetail: action.payload,
        displayObj: displayObj2,
      };
    case actionTypes.GET_ADJUSTED_CLAIMS_ALL_DATA:
      return { ...state, drugSeqData: action.payload };
    case actionTypes.SET_PROVIDER_CD:
      return { ...state, providerCd: action.payload };
    case actionTypes.REFRESH_NDC_DETAILS:
      return {
        ...state,
        performAdjustedResolutionObj: {},
        rebateProgram: [],
        rebateProgramName: {},
        claimCategoryName: '',
        errorMsgAdjustedClaim: [],
        labelerList: [],
        labelerData: [],
        labelerInfo: [],
        // labelerInfoName: [],
        billed: true,
        notBilled: false,
        yes: true,
        no: false,
        invoice: true,
        nonInvoiced: false,
        startQtr: '',
        endQtr: '',
        drugSeqNum: [],
        drugSeqData: [],
        selectBy: 'All',
        claimcategorySelectedValue: '',
        selectedNDC: [],
        ndcLeftTableData: [],
        labelerSelectedRow: [],
        selectRowIndex: 0,
        selectedSearchType: 'Name',
      };

    case actionTypes.SET_PAGINATION_INDEX_ADJUTED_CLAIMS:
      return {
        ...state,
        displayObj: { ...state.displayObj, countValue: action.payload },
      };

    default:
      return state;
  }
};
export default reducer;
